// FIXME: ↓このimport文があるとHMRが効かないので作業中はコメントアウトしておく…
import PhantomViewer from 'phantom-viewer'

document.addEventListener('turbo:load', async () => {
  const container = document.getElementById('phantom-viewer-container')
  if (container) {
    new PhantomViewer('simple-panorama', { filePath: container.dataset.panoramaImageUrl, startLocationId: 'panorama' })
  }
})
